export default "<div [id]=\"viewerId\" class=\"reportContainer\"></div>"